import Portal from '@dc/ui-library/src/gadgets/Portal/';
import Button from '@dc/ui-library/src/molecules/Button/Button';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveFiltersCount } from './filterHelpers';

class FiltersToggleButton extends PureComponent {
  render() {
    const domNode = document.querySelector('div.list-page-filter-button');
    if (!domNode) {
      return null;
    }

    return (
      <Portal domNode={domNode}>
        <Button
          onClick={this.props.onClick}
          style="small-outline"
        >
          <Icon icon="Filter" />
          &nbsp;
          Filter ({this.props.activeFiltersCount})
        </Button>
      </Portal>
    );
  }
}

FiltersToggleButton.displayName = 'FiltersToggleButton';

FiltersToggleButton.propTypes = {
  activeFiltersCount: PropTypes.number,
  onClick: PropTypes.func
};

FiltersToggleButton.defaultProps = {
  activeFiltersCount: 0,
  onClick: () => {}
};

function mapStateToProps() {
  return {
    activeFiltersCount: getActiveFiltersCount()
  };
}

export default connect(mapStateToProps)(FiltersToggleButton);
